<div class="additional-field-add" [formGroup]="additionalFieldForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!additionalFieldForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">

    <mat-card fxFlex="100">
      <div fxLayout="column" fxLayoutGap="15px">
        <h3>Dane</h3>

        <div fxLayout="row" fxLayoutGap="15px">
            <mat-form-field  class="add-input" fxFlex="50">
              <mat-label>Nazwa</mat-label>
              <input matInput placeholder="Nazwa" formControlName="name" [required]="true">
              <mat-error *ngIf="additionalFieldForm.get('name')?.hasError('backendError')">
                {{additionalFieldForm.get('name')?.errors?.backendError}}
              </mat-error>
            </mat-form-field>

          <app-dict fxFlex="50" dictType="field_type" label="Typ"
                    [control]="fieldTypeControl"
                    [required]="true"></app-dict>
        </div>

        <mat-slide-toggle fxFlex="100" color="accent" formControlName="active">Aktywny</mat-slide-toggle>
      </div>
    </mat-card>

  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!additionalFieldForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
